import { render, staticRenderFns } from "./IndexValuesChart.vue?vue&type=template&id=2774b9b0&"
import script from "./IndexValuesChart.vue?vue&type=script&lang=js&"
export * from "./IndexValuesChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports